import React from '../../vendor/react';
import { useState } from '../../vendor/react';
import { CircleCheck, Mail } from '../../vendor/lucide-react';
import { currentSearch, Link, navigate } from '../../vendor/react-router-dom';
import { AuthLayout } from '../../components/auth/AuthLayout';
import { AuthNotice } from '../../components/auth/AuthNotice';
import { Button } from '../../components/ui/Button';
import { useAuth } from '../../features/auth/auth-store';

export function ConfirmationPage() {
  const auth = useAuth();
  const params = new URLSearchParams(currentSearch());
  const email = params.get('email') ?? 'tu correo';
  const token = params.get('token') ?? '';
  const [error, setError] = useState('');

  const confirm = async () => {
    if (!token) return;
    try {
      await auth.actions.confirmEmail(token);
      navigate('/onboarding', { replace: true });
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'No se pudo confirmar el correo.');
    }
  };

  return (
    <AuthLayout eyebrow="Confirma tu cuenta" title="Revisa tu correo" description={`Enviamos las instrucciones de confirmación a ${email}.`}>
      <div className="auth-confirmation-icon"><Mail size={30} /></div>
      {error && <AuthNotice tone="error">{error}</AuthNotice>}
      <div className="confirmation-copy"><p>Después de confirmar, podrás crear tu organización, negocio y primera sucursal.</p><span>El enlace expira y no puede utilizarse dos veces.</span></div>
      {auth.providerMode === 'local' && token && <Button size="lg" className="full-width" icon={<CircleCheck size={18} />} onClick={confirm}>Confirmar correo en modo local</Button>}
      <p className="auth-card__footer">¿Ya confirmaste? <Link to="/ingresar">Volver al acceso</Link></p>
    </AuthLayout>
  );
}
